import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Outcomesnde() {
  return (
    <section className="outcomes_nde p-100 text_nde">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center resp_order"
          >
            <div className="outcome_img_nde">
              <StaticImage
                src="../../../images/case-studies/nde/outcomes.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={652}
                height={601}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="offset-xl-1 offset-lg-1 my-auto"
          >
            <h2>What were the Outcomes?</h2>
            <p>
              The updated version of the website and the web portals were
              bug-free, fast, and efficient. The reloading time improved
              dramatically, while the user experience and the overall feel of
              the website and web portals enhanced the credibility of the
              business.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Outcomesnde;
